import(/* webpackMode: "eager" */ "/codebuild/output/src1387067105/src/vatrik_technologies/src/app/not-found.tsx");
